import { render, staticRenderFns } from "./GuessWordComponent.vue?vue&type=template&id=082eeb48&scoped=true&"
import script from "./GuessWordComponent.vue?vue&type=script&lang=js&"
export * from "./GuessWordComponent.vue?vue&type=script&lang=js&"
import style0 from "./GuessWordComponent.vue?vue&type=style&index=0&id=082eeb48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082eeb48",
  null
  
)

export default component.exports